<div class="nc-wrap" [ngStyle]="themeVars">

	<!-- ── Floating accent icon ─────────────────────────────────────────────── -->
	<div class="nc-icon-badge">
		<i class="material-icons">person_add</i>
	</div>

	<!-- ── Header ───────────────────────────────────────────────────────────── -->
	<div class="nc-header">

		<div class="nc-title-group">
			<span class="nc-title">New Customers</span>
			<span class="nc-subtitle" *ngIf="range && range.controls.start.value && range.controls.end.value">
				{{ range.controls.start.value | date:'MMM d' }} – {{ range.controls.end.value | date:'MMM d, y' }}
			</span>
		</div>

		<div class="nc-actions">
			<button class="nc-icon-btn" (click)="loadData()" [disabled]="sending" title="Refresh">
				<i class="material-icons">refresh</i>
			</button>
			<button class="nc-icon-btn" (click)="exportXls()" [disabled]="sending || flip !== 'active' || !filteredData?.length" title="Export Excel">
				<i class="fa fa-file-excel-o"></i>
			</button>
			<button class="nc-icon-btn" (click)="exportPdf()" [disabled]="sending || flip !== 'active' || !filteredData?.length" title="Export PDF">
				<i class="fa fa-file-pdf-o"></i>
			</button>
			<button class="nc-icon-btn"
					[class.nc-icon-btn--active]="flip === 'active'"
					(click)="toggleFlip(data, title)"
					[disabled]="!data"
					[title]="flip === 'active' ? 'Collapse details' : 'View details'">
				<i class="material-icons">{{ flip === 'active' ? 'expand_less' : 'expand_more' }}</i>
			</button>
		</div>
	</div>

	<!-- ── Summary stats ────────────────────────────────────────────────────── -->
	<div class="nc-stats" *ngIf="data && !sending">
		<div class="nc-stat">
			<span class="nc-stat-val">{{ total }}</span>
			<span class="nc-stat-lbl">New Customers</span>
		</div>
		<!-- No Period tile: the range is already in the header subtitle and in the
		     Date Range field, and a third tile squeezed all three to ellipses. -->
		<div class="nc-stat nc-stat--wide">
			<span class="nc-stat-val" [title]="topAccount">{{ topAccount }}</span>
			<span class="nc-stat-lbl">Top Account</span>
		</div>
	</div>

	<!-- ── Loading ──────────────────────────────────────────────────────────── -->
	<div class="nc-loading" *ngIf="sending">
		<svg class="spinner" width="40" height="40" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
			<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
		</svg>
	</div>

	<!-- ── Collapsed hint ───────────────────────────────────────────────────── -->
	<div class="nc-view-row" *ngIf="flip !== 'active' && data && !sending">
		<button class="nc-view-btn" (click)="toggleFlip(data, title)">
			<i class="material-icons">table_rows</i>
			<span>View Details</span>
		</button>
	</div>

	<!-- ── Detail panel (slides open) ───────────────────────────────────────── -->
	<div class="nc-detail" *ngIf="flip === 'active' && !sending">

		<!-- Filters -->
		<div class="nc-filters">
			<mat-form-field appearance="outline" class="nc-field nc-field--dates">
				<mat-label>Date Range</mat-label>
				<mat-date-range-input [formGroup]="range" [rangePicker]="picker" (dateChange)="onDateRangeChange($event)">
					<input matStartDate formControlName="start" placeholder="Start date">
					<input matEndDate formControlName="end" placeholder="End date">
				</mat-date-range-input>
				<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
				<mat-date-range-picker #picker></mat-date-range-picker>
			</mat-form-field>

			<mat-form-field appearance="outline" class="nc-field">
				<mat-label>Search</mat-label>
				<input matInput type="text" [(ngModel)]="searchTerm" (input)="onSearchChange()" placeholder="Filter rows…">
				<i matSuffix class="material-icons nc-search-icon">search</i>
			</mat-form-field>
		</div>

		<!-- Table -->
		<div class="nc-table-wrap" *ngIf="filteredData && filteredData.length" #print_table>
			<table class="nc-table">
				<thead>
					<tr>
						<th class="pointer" (click)="sort('debtorno')">
							Customer#
							<i class="material-icons sort-icon" *ngIf="sortColumn==='debtorno'">{{ sortDirection==='asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}</i>
						</th>
						<th class="pointer" (click)="sort('name')">
							Name
							<i class="material-icons sort-icon" *ngIf="sortColumn==='name'">{{ sortDirection==='asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}</i>
						</th>
						<th class="pointer" (click)="sort('address1')">
							Address 1
							<i class="material-icons sort-icon" *ngIf="sortColumn==='address1'">{{ sortDirection==='asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}</i>
						</th>
						<th class="pointer" (click)="sort('address3')">
							City
							<i class="material-icons sort-icon" *ngIf="sortColumn==='address3'">{{ sortDirection==='asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}</i>
						</th>
						<th class="pointer" (click)="sort('address4')">
							Region
							<i class="material-icons sort-icon" *ngIf="sortColumn==='address4'">{{ sortDirection==='asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}</i>
						</th>
						<th class="pointer" (click)="sort('address5')">
							Postal
							<i class="material-icons sort-icon" *ngIf="sortColumn==='address5'">{{ sortDirection==='asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}</i>
						</th>
						<th class="pointer" (click)="sort('salesmanname')">
							Sales Person
							<i class="material-icons sort-icon" *ngIf="sortColumn==='salesmanname'">{{ sortDirection==='asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}</i>
						</th>
						<th class="pointer" (click)="sort('lastseen')">
							Last Seen
							<i class="material-icons sort-icon" *ngIf="sortColumn==='lastseen'">{{ sortDirection==='asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}</i>
						</th>
						<th class="pointer text-right" (click)="sort('totalspend')">
							Total Spend
							<i class="material-icons sort-icon" *ngIf="sortColumn==='totalspend'">{{ sortDirection==='asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}</i>
						</th>
						<th class="pointer text-right" (click)="sort('avgspend')">
							Avg Spend
							<i class="material-icons sort-icon" *ngIf="sortColumn==='avgspend'">{{ sortDirection==='asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}</i>
						</th>
						<th *ngIf="isMoov" class="pointer" (click)="sort('cosm_license')">
							OCM License
							<i class="material-icons sort-icon" *ngIf="sortColumn==='cosm_license'">{{ sortDirection==='asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}</i>
						</th>
					</tr>
				</thead>

				<tbody>
					<tr *ngFor="let d of filteredData">
						<td>
							<a [routerLink]="'/customers/view/' + d.debtorno" class="nc-cust-link">{{ d.debtorno }}</a>
						</td>
						<td class="nc-cell-label">{{ d.name }}</td>
						<td>{{ d.address1 }}</td>
						<td>{{ d.address3 }}</td>
						<td>{{ d.address4 }}</td>
						<td>{{ d.address5 }}</td>
						<td>
							<span *ngIf="d.salesmanname">{{ d.salesmanname.name }}</span>
						</td>
						<td>{{ d.lastseen }}</td>
						<td class="text-right nc-cell-total">{{ d.totalspend | currency }}</td>
						<td class="text-right nc-cell-total">{{ d.avgspend | currency }}</td>
						<td *ngIf="isMoov">{{ d.details?.cosm_license || '' }}</td>
					</tr>
				</tbody>
			</table>
		</div>

		<!-- Empty -->
		<div class="nc-empty" *ngIf="!filteredData || !filteredData.length">
			<i class="material-icons">search_off</i>
			<span>No new customers for the selected period.</span>
		</div>

	</div>
</div>
